import React from "react";
import styled from "styled-components";
import useTheme from "../../lib/useTheme";

type Props = {
  size?: "large" | "medium" | "small";
  selected?: boolean;
  onClick: Function;
};

const Dot: React.FC<Props> = ({ size = "large", selected, onClick }) => {
  const theme = useTheme();
  return (
    <StyledComponent
      $theme={theme}
      className={"dgaui_carouselDot " + size + (selected ? " selected" : "")}
      onClick={() => onClick()}
    />
  );
};

const StyledComponent = styled.div<{ $theme: Theme }>`
  background-color: ${(p) => p.$theme.palette.neutral[200]};
  border-radius: 100%;
  margin-inline-end: 8px;
  cursor: pointer;

  &.large {
    width: 16px;
    height: 16px;
  }
  &.medium {
    width: 12px;
    height: 12px;
  }
  &.small {
    width: 8px;
    height: 8px;
  }
  &.selected {
    background-color: ${(p) => p.$theme.palette.primary[600]};
  }
`;

export default Dot;
